// ============================================
// HEISE WELLNESS WEBSITE CONTENT
// ============================================
// Edit any text below - just change what's between the quotes!
// Save the file and refresh your browser to see changes.
// NO CODING KNOWLEDGE NEEDED - just edit the text you want to change.

export const content = {
  
  // ==================== HERO SECTION ====================
  hero: {
    mainHeading: "This is not therapy.",
    subHeading: "For those who've outgrown traditional therapy and are ready for what comes next.",
    buttonText: "My Path Forward"
  },

  // ==================== CONCIERGE EXPERIENCE SECTION ====================
  bespoke: {
    heading: "A Concierge Experience",
    paragraph1: "Our approach is grounded in the belief that wellness happens when the mind, body, and inner wisdom work together. We offer a tailored experience led by a highly trained mental health professional, integrating somatic healing and yoga-based practices that empower you to thrive.",
    paragraph2: "We bring expertise, presence, and care to your Greater Chicago home or office and virtually, honoring your time, privacy, and personal space.",
    
    // Three pillars
    pillars: {
      mind: {
        title: "Mind",
        description: "Cognitive insights and experiential reprocessing to understand your unique narrative."
      },
      body: {
        title: "Body",
        description: "Somatic practices like yoga and breathwork, coupled with smell and touch to reconnect with your physical self."
      },
      wisdom: {
        title: "Wisdom",
        description: "Intuitive coaching and guided imagery to access your authentic voice and personal truth."
      },
    }
  },

  // ==================== SERVICES SECTION ====================
  services: {
    heading: "Our Services",
    subheading: "Based in the Greater Chicago Area, we are not bound by insurance billing codes, diagnoses, or 'standard hour' sessions. You determine your own session length and frequency. Each plan is designed for your path to transformation, integrating clinical expertise with holistic wisdom, delivered with discretion in the sanctuary of your space.",
    additionalNote: "We stay in touch! You will not be charged for consultations between sessions.",
    // Initial Session
    initialSession: {
      title: "Initial Session",
      duration: "90 minutes",
      location: "In your home or office",
      description: "We'll begin with a comprehensive consultation to explore your story, intentions, and goals through a thorough assessment of physical, emotional, and energetic patterns.",
      features: [
        "Complete intake and biomechanical assessment",
        "Personalized goal setting",
        "Somatic integration techniques",
        "Recommendations for home practice"
      ]
    },

    // Follow-Up Sessions
    followUpSession: {
      title: "Follow-Up Sessions",
      duration: "60 to 180 minutes",
      location: "In your home or office",
      description: "Building upon our initial work, these sessions deepen your practice with convenience. Every session is responsive to your evolving needs, incorporating somatic practices, breathwork, and intuitive guidance in a space where you feel at ease.",
      features: [
        "Progress evaluation and integration",
        "Develop evidence-based strategies to reach your goals",
        "Breathwork, guided imagery, incorporation of all 5 senses",
        "Continued support between sessions-available wherever you are"
      ]
    },


    // Private Yoga Instruction
    privateYoga: {
      title: "Private Yoga Instruction",
      location: "In your home or office",
      description: "Experience one-on-one yoga instruction tailored to your body and goals, delivered in your personal space. Inquire about group sessions."
    },

    // Exclusive Membership
    exclusiveMembership: {
      title: "Exclusive Membership",
      location: "Concierge-level care with Priority Scheduling",
      description: "Designed for those who value their time and privacy. Due to the highly personalized nature of our concierge services, only a small number of clients are accepted at a time. Excellence is our priority. Please contact us to learn more."
    },

    // Virtual Support
    virtualSupport: {
      title: "Virtual Support",
      location: "On your mobile device or computer",
      description: "Ongoing, solution-focused guidance at optimized pricing. Sessions include integration of mind, body, and wisdow in a virtual format."
    
    },
  },

  // ==================== ABOUT SECTION ====================
  about: {
    name: "Jessica Heise",
    title: "Founder",
    credentials: "LCSW, RYT, LMHP",
    
    bio: [
      "It may sound dramatic, but yoga saved my life. I was unable to manage my anxiety or accept the major life changes I faced as a young adult. I had already started my path into the mental health field, working for an agency that supported unhoused youth. I loved the dynamic nature of outreach, going under train systems, into encampments, and most importantly, witnessing positive transformations in people's lives! A passion was sparked, but I needed a way to regulate. I found yoga through a neighbor, who loaned me DVDs. I followed along with those and the yoga classes on public broadcast channels.",
      
      "I have been practicing yoga for over 20 years and have spent more than 15 years working in mental health. During that time, I’ve also completed specialized training in healing methods that focus on trauma, recovery from trauma, how the nervous system works, and proven mental health approaches.",

      "In my 40s, I was diagnosed with an autoimmune disease, and long-standing patterns in my body finally came into focus. What I had experienced for years began to make sense, opening the door to clarity, self-understanding, and a more intentional way forward.",
      
      "I hold a Master of Social Work from the Jane Addams School of Social Work - University of Illinois at Chicago. I am an experienced Registered Yoga Teacher and a member of the Chicago Art Therapy Collective. I approach yoga, somatic healing, and trauma reprocessing through a whole person lens. Each story and process is unique.",
      
      "In my free time, I am usually gardening, foraging, reading, cycling, playing guitar, painting, enjoying live music, or walking my dogs.",
      
      "You could spend hours scrolling through social media wellness accounts, or you can follow a path guided by experience. I am thrilled to be a part of your incredible journey."
    ]
  },

  // ==================== PRICING & CONTACT SECTION ====================
  pricing: {
    heading: "Pricing",
    paragraph1: "Rates are customized based on your location, scheduling needs, and service preferences.",
    paragraph2: "Contact us for a confidential consultation to discuss how we can best support your journey.",
    buttonText: "Schedule a Private Consultation",
    
    contactHeading: "Get in Touch",
    email: "jessica@heisewellness.com",
    confidentialityNote: "All inquiries are handled with confidentiality",
    
    // Partnerships
    partnershipsHeading: "Corporate & Wellness Partnerships",
    partnershipsDescription: "We collaborate with corporations, executive leadership teams, wellness centers, spas, and luxury hospitality environments through our referral program—providing discreet, high-touch services for discerning clients and their teams.",
    partnershipsLinkText: "Inquire about partnership opportunities →"
  },

  // ==================== HEADER NAVIGATION ====================
  navigation: {
    brandName: "Heise Wellness",
    menuItems: [
      { id: "home", label: "HOME" },
      { id: "about", label: "ABOUT" },
      { id: "services", label: "SERVICES" },
      { id: "contact", label: "CONTACT" },
      { id: "partnerships", label: "PARTNERSHIPS" },
      { id: "admin", label: "ADMIN" }
    ],
  },

  // ==================== FOOTER ====================
  footer: {
    brandName: "Heise Wellness",
    tagline: "Elite framing for people seeking collaborators in their healing journey.",
    contactHeading: "Contact",
    email: "jessica@heisewellness.com",
    clientPortalHeading: "Client Access",
    clientPortalLink: "Client Portal",
    clientPortalNote: "Access notes and billing",
    copyrightText: "Heise Wellness. All rights reserved."
  }
};
